import { PropsWithChildren } from "react";
import { description, percentValue, percentValueContainer } from "./styles.css";

export const PercentValue = ({
  children,
  value,
}: PropsWithChildren<{ value: number }>) => {
  return (
    <div className={percentValueContainer}>
      <span className={percentValue}>{value}</span>
      <span className={description}>{children}</span>
    </div>
  );
};
